import { Button } from "components"
import { TabSubTransactionType, TabSubTransactionProps } from "../types"

export function TabSubTransaction({ activeTab, setActiveTab , disablePath}: TabSubTransactionProps) {

  const tabs: TabSubTransactionType[] = [
    { label: "BILL ITEM", path: "bill", permission: "SUBSCRIBED" },
    { label: "PAYMENT BILL ITEM", path: "payment_bill_item", permission: "SUBSCRIBED" },
    { label: "BILL SERVICE", path: "service_bill", permission: "SUBSCRIBED" },
    { label: "PAYMENT BILL SERVICE", path: "payment_bill_service", permission: "SUBSCRIBED" },
    { label: "INVOICE", path: "invoice", permission: "SUBSCRIBED" },
    { label: "RECEIVED INVOICE", path: "payment_invoice", permission: "SUBSCRIBED" },
    { label: "SPEND MONEY", path: "spend_money", permission: "SUBSCRIBED" },
    { label: "RECEIVED MONEY", path: "received_money", permission: "SUBSCRIBED" },
  ]

  return (
    <div className="grow w-full! bg-black! flex items-stretch overflow-x-auto z-[1]">
      {tabs.map((tab) => (
        <Button
          key={tab.path}
          permission={tab?.permission}
          type="button"
          color="ghost"
          size="sm"
          disabled={disablePath?.includes(tab.path) ?? false}
          className={`mr-0.5 min-w-[100px] bg-[#3c3c3c] border-y-0 border-x no-animation hover:bg-primary hover:text-black uppercase ${tab.path === activeTab ? "bg-primary text-black" : "text-white"}`}
          onClick={() => setActiveTab(tab.path)}
        >
          {tab.label}
        </Button>
      ))}
    </div>
  )
}
